export default {
      id: "sync-usage",
      viewBox: "0 0 14 15",
      url: __webpack_public_path__ + "img/icons.svg#sync",
      toString: function () {
        return this.url;
      }
    }